import { UserDetail } from '../../../components/User';
import { UserType } from '../../../types';

export function MemberUser() {
  return <UserDetail type={UserType.Member} />;
}
